import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

export const searchParamsToObject = (params: URLSearchParams): QueryParams =>
  [...params.entries()].reduce((acc, [key, value]) => ({...acc, [key]: value}), {})
export const queryToObject = (query?: string): QueryParams =>
  searchParamsToObject(new URLSearchParams(query))
